import { useMemo } from 'react';

import { useMetadata } from 'contexts/Metadata';
import SingleSelectField from 'fields/SingleSelectField';

import type { ITransportMethodField } from './types';

const TransportMethodField = ({ name, label, placeholder, onChange }: ITransportMethodField) => {
  const {
    state: { transportMethods },
  } = useMetadata({ loadTransportMethodsData: true });

  const options = useMemo(() => transportMethods, [transportMethods]);

  return (
    <SingleSelectField
      data-testid="transport-method-field"
      name={name}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      options={options}
    />
  );
};
export default TransportMethodField;
